
function Footer() {
  return (
    <div className='footer'>
      <footer>
        <p className='copywrite'>© jckrft 2021</p>
      </footer>
    </div>
  )
}

export default Footer;
